<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="form-main cus-infoes">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="formData">
                <div class="formData-top">
                    <div class="form-left form-column">
                        <el-form-item label="客户名称" prop="Name">
                            <el-input size="small" v-model="formData.Name" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="客户来源">
                            <el-select size="small" filterable clearable allow-create v-model="formData.Source" :disabled="isReadOnly" style="width: 70%">
                                <el-option v-for="optionItem in sourceList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value"></el-option>
                            </el-select>
                            <el-button icon="el-icon-edit" type="text" style="margin-left: 5px" @click="showSourceDialog" v-if="!isReadOnly">编辑</el-button>
                        </el-form-item>
                    </div>
                    <div class="form-center form-column">
                        <el-form-item label="手机号" prop="CallNum">
                            <el-input size="small" v-model="formData.CallNum" :maxlength="20" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="电子邮箱">
                            <el-input size="small" v-model="formData.Email" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                    </div>
                    <div class="form-right form-column">
                        <el-form-item label="其他联系人">
                            <el-input size="small" v-model="formData.Contactor" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人电话" prop="PhoneNum">
                            <el-input size="small" v-model="formData.PhoneNum" :maxlength="20" :disabled="isReadOnly"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <div>
                        <el-form-item label="国家" prop="CountryId">
                            <el-select
                                size="small"
                                v-model="formData.Country"
                                style="width: 186px"
                                filterable
                                clearable
                                value-key="CountryName"
                                @change="countryChange"
                                placeholder="请选择"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in countryList" :key="item.CountryId" :label="item.CountryName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="省市区">
                            <el-select
                                size="small"
                                v-model="formData.Province"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="ProvinceName"
                                @change="provinceChange"
                                placeholder="请选择省"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in provinceList" :key="item.ProvinceId" :label="item.ProvinceName" :value="item"></el-option>
                            </el-select>
                            <el-select
                                size="small"
                                v-model="formData.City"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="CityName"
                                @change="cityChange"
                                placeholder="请选择市"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in cityList" :key="item.CityId" :label="item.CityName" :value="item"></el-option>
                            </el-select>
                            <el-select
                                size="small"
                                v-model="formData.Zone"
                                style="width: 164px"
                                filterable
                                clearable
                                value-key="DistrictName"
                                @change="zoneChange"
                                placeholder="请选择区"
                                :disabled="isReadOnly"
                            >
                                <el-option v-for="item in zoneList" :key="item.DistrictId" :label="item.DistrictName" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="formData-bottom">
                    <el-form-item label="详细地址">
                        <el-input size="small" v-model="formData.Address" style="width: 493px" maxlength="180" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/add.png" class="addicon" @click="addAddress()" title="添加地址" v-if="!isReadOnly" />
                    <el-form-item label="区号" label-width="64px">
                        <div class="form-value" style="width: 96px">
                            {{ formData.ZoneNum }}
                        </div>
                    </el-form-item>
                    <el-form-item label="邮编" label-width="54px">
                        <el-input style="width: 96px" size="small" v-model="formData.Zipcode" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                </div>
                <div class="formData-bottom" v-if="showSecAddr">
                    <el-form-item label="地址2">
                        <el-input size="small" v-model="formData.Address2" style="width: 493px" maxlength="150" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/del.png" class="addicon" @click="delAddress(2)" v-if="!isReadOnly" />
                </div>
                <div class="formData-bottom" v-if="showThirdAddr">
                    <el-form-item label="地址3">
                        <el-input size="small" v-model="formData.Address3" style="width: 493px" maxlength="150" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <img src="../../../assets/images/del.png" class="addicon" @click="delAddress(3)" v-if="!isReadOnly" />
                </div>
                <div class="formData-bottom">
                    <el-form-item label="备注">
                        <el-input size="small" v-model="formData.Infoes" style="width: 500px" :disabled="isReadOnly"></el-input>
                    </el-form-item>
                    <el-form-item label="跟进业务员">
                        <el-select size="small" v-model="formData.FollowerId" class="search-item" filterable placeholder="请选择" clearable :disabled="true">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="formData-bottom" v-if="type == 1 || type == 2">
                    <el-form-item style="height: 110px" label="智能填写" v-if="type == 1 || type == 2">
                        <el-input
                            size="small"
                            v-model="smContent"
                            type="textarea"
                            style="width: 818px"
                            :rows="5"
                            placeholder="比如：广东省珠海市香洲区盘山路28号幸福茶庄,陈景勇，13593464918"
                        ></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialog-footer" v-if="!isReadOnly">
                <el-button class="search-btn" size="small" type="warning" v-if="type == 1 || type == 2" @click="smAddress">地址智能识别</el-button>
                <el-button class="btn-primary" size="small" @click="submitForm">提交保存</el-button>
                <el-button size="small" @click="cancel()">取消</el-button>
            </div>
        </div>
        <customerSource v-if="sourceVisible" :dialogFormVisible="sourceVisible" @closeSourceDialog="closeSourceDialog"></customerSource>
    </div>
</template>
<script>
import customerSource from '@/components/business/customerManage/customerSource';
export default {
    props: ['type', 'cusId', 'fromPage'], // type 1 新增 2 编辑    source 1 客户 2 供应商   fromPage 1 客户列表  2 销售开单页
    components: {
        customerSource
    },
    name: '',
    data() {
        let checkEmail = this.$util.checkEmail;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            loading: false,
            sourceVisible: false,
            isReadOnly: false,
            countryCode: '86',
            sourceList: [],
            countryList: [],
            provinceList: [],
            SIdList: [],
            cityList: [],
            zoneList: [],
            showSecAddr: false,
            showThirdAddr: false,
            formData: {
                EntpCusId: this.type == 1 ? '' : this.cusId,
                Tags: '',
                Name: '',
                Abbr: '',
                Source: '',
                CallNum: '',
                Qq: '',
                WeChat: '',
                Payment: '',
                Email: '',
                Address: '',
                Address2: '',
                Address3: '',
                Zipcode: '',
                ZoneNum: '86',
                MainPartName: '',
                MainVehicle: '',
                Contactor: '',
                PhoneNum: '',
                Position: '',
                Infoes: '',
                Website: '',
                Country: {
                    CallCode: '86',
                    CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                    CountryName: '中国'
                },
                CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                Province: {},
                ProvinceId: '',
                City: {},
                CityId: '',
                Zone: {},
                ZoneId: '',
                FollowerId: '',
                LogisticId: '',
                LogisticName: '',
                PayType: '',
                MaxCreditMoney: 0,
                CreditDay: 0,
                CreditType: '0',
                LevelId: '',
                PictureList: [],
                IsRecommend: true
            },
            rules: {
                Name: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                CountryId: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ],
                CallNum: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                    // {validator:checkPhone, trigger: 'blur'},
                ],
                Email: [
                    {
                        validator: checkEmail,
                        trigger: 'blur'
                    }
                ],
                PhoneNum: [
                    // {validator:checkPhone, trigger: 'blur'},
                ]
            },
            smContent: ''
        };
    },
    mounted() {
        if (this.type == 3) this.isReadOnly = true;
        this.initPage();
    },
    methods: {
        async initPage() {
            this.loading = true;
            await this.getCountryList();
            await this.getSourceList();
            if (this.source == 1) await this.getPay();
            await this.getSIdList();

            if (this.type == 1) await this.getProvinceList(this.formData.Country.CountryId);
            else this.getCustomer();

            this.loading = false;
        },
        async getCustomer() {
            let url = '/api/EntpCustomers/GetEnterpriseCustomer';
            let res = await this.$util
                .axiosGet({
                    url: url,
                    data: {
                        EntpCusId: this.cusId
                    }
                })
                .catch(() => {});
            let data = res.data;
            data.EntpCusId = this.cusId;

            let CountryId = this.formData.CountryId;
            let Country = this.formData.Country;

            this.formData = data;
            if (!this.formData.CountryId) {
                this.formData.CountryId = CountryId;
                this.formData.Country = Country;
            }

            if (data.LogisticId) {
                this.lcOptions.push({ EntpCusId: data.LogisticId, EntpCusName: data.LogisticName });
            }

            if (this.source == 1) {
                if (this.formData.Address2) this.showSecAddr = true;

                if (this.formData.Address3) this.showThirdAddr = true;
            }

            if (data.CountryId) {
                this.getProvinceList(data.CountryId);
            }

            if (data.ProvinceId) {
                this.getCityList(data.ProvinceId);
            }
            if (data.CityId) {
                this.getZoneList(data.CityId);
            }
        },
        // 提交表单
        submitForm() {
            let that = this;
            let url = '/api/EntpCustomers/SaveEntpCus_EC';
            that.$refs.formData.validate(valid => {
                if (valid) {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: url,
                            data: that.formData,
                            hideLoading: true
                        })
                        .then(resp => {
                            if (resp.errcode == 0) {
                                if (that.type == 1) {
                                    that.$util.successMsg('添加成功');
                                } else {
                                    that.$util.successMsg('修改成功');
                                }
                                if (that.fromPage != 1) that.$emit('closeDialog', 'used', resp.data, that.formData.Name);
                                else that.$emit('closeDialog', 'edit', that.formData.EntpCusId, that.formData.Name);
                            }
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                } else {
                    this.$util.errorMsg('校验不通过');
                    return false;
                }
            });
        },
        cancel() {
            this.$emit('closeDialog', 'cancel');
        },
        showSourceDialog() {
            this.sourceVisible = true;
        },
        closeSourceDialog() {
            this.getSourceList();
            this.sourceVisible = false;
        },
        countryChange(value) {
            this.formData.CountryId = value.CountryId;
            this.countryCode = value.CallCode;
            this.formData.ZoneNum = value.CallCode;
            this.formData.ProvinceId = '';
            this.formData.Province = {};
            this.formData.CityId = '';
            this.formData.City = {};
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.cityList = [];
            this.zoneList = [];
            this.getProvinceList(value.CountryId);
        },
        provinceChange(value) {
            this.formData.ProvinceId = value.ProvinceId;
            this.formData.CityId = '';
            this.formData.City = {};
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.getCityList(value.ProvinceId);
        },
        cityChange(value) {
            let _CallCode = value.CallCode ? parseInt(value.CallCode).toString() : '';
            this.formData.CityId = value.CityId;
            this.formData.ZoneNum = this.countryCode + _CallCode;
            this.formData.ZoneId = '';
            this.formData.Zone = {};
            this.getZoneList(value.CityId);
        },
        zoneChange(value) {
            this.formData.ZoneId = value.DistrictId;
            this.formData.Zone = value.DistrictName;
        },
        getSourceList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpCustomers/GetEnterpriseCustomerSources',
                        hideLoading: true
                    })
                    .then(res => {
                        this.sourceList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getCountryList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCountryList',
                        hideLoading: true
                    })
                    .then(res => {
                        this.countryList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getProvinceList(CountryId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetProvinceList',
                        data: {
                            CountryId: CountryId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.provinceList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getCityList(ProvinceId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCityList',
                        data: {
                            ProvinceId: ProvinceId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.cityList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        getZoneList(CityId) {
            this.$util
                .axiosGet({
                    url: '/api/Region/GetDistrictList',
                    data: {
                        CityId: CityId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.zoneList = res.data;
                })
                .catch(() => {});
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
                //跟进人默认是当前账号
                let fo = data.find(f => f.EmployeeId == this.userMsg.EmployeeId);
                if (!fo) {
                    this.SIdList.unshift({ EmployeeId: this.userMsg.EmployeeId, EmployeeName: this.userMsg.EmployeeName, IsDismiss: false });
                    this.formData.FollowerId = this.userMsg.EmployeeId;
                }

                this.formData.FollowerId = this.userMsg.EmployeeId;
            });
        },
        addAddress() {
            let that = this;
            if (that.formData.Address) {
                if (that.showSecAddr && !that.showThirdAddr) {
                    if (that.formData.Address2) that.showThirdAddr = true;
                    else this.$util.errorMsg('请先填写【地址2】，再进行添加【地址3】');
                } else if (that.showSecAddr && that.showThirdAddr) this.$util.errorMsg('目前仅支持新增3个地址');
                else that.showSecAddr = true;
            } else this.$util.errorMsg('请先填写【详细地址】，再进行添加【地址2】');
        },
        delAddress(idx) {
            let that = this;
            switch (idx) {
                case 2:
                    that.showSecAddr = false;
                    that.formData.Address2 = '';
                    break;
                case 3:
                    that.showThirdAddr = false;
                    that.formData.Address3 = '';
                    break;
            }
        },
        smAddress() {
            let that = this;
            if (!that.smContent) return;

            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpCustomers/SMAddress',
                    data: {
                        address: that.smContent,
                        isAdd: that.type == 1 && that.source == 1
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode != 0) return;
                    let data = res.data;

                    if (data.Name) that.formData.Name = data.Name;
                    if (data.CallNum) that.formData.CallNum = data.CallNum;
                    if (data.Address) that.formData.Address = data.Address;

                    if (data.ProvinceId) {
                        that.formData.ProvinceId = data.ProvinceId;
                        that.formData.Province = data.Province;
                        that.getCityList(data.ProvinceId);

                        if (data.CityId) {
                            that.formData.CityId = data.CityId;
                            that.formData.City = data.City;
                            this.getZoneList(data.CityId);

                            if (data.ZoneId) {
                                that.formData.ZoneId = data.ZoneId;
                                that.formData.Zone = data.Zone;
                            }
                        }
                    }

                    if (data.IsExistCus && that.type == 1 && that.source == 1 && data.EntpCusId && that.fromPage != 1) {
                        let txt = '检测到客户资料已存在，是否直接使用已存在的客户资料？如使用，有地址时则注意核实发货地址';

                        if (that.cusId) {
                            txt = '检测到客户资料已存在！';
                        }

                        //放到最后，反正上面赋值完也没有问题
                        if (data.IsExistCus) {
                            that.$confirm(txt, '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                                center: false
                            })
                                .then(() => {
                                    if (!that.cusId) that.$emit('closeDialog', 'used', data.EntpCusId, data.CusName);
                                })
                                .catch(() => {});
                        }
                    }

                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.formData-bottom {
    display: flex;
}
.form-value {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    width: 100%;
}
.form-column {
    width: 33.33%;
}
.form-column2 {
    width: 66.66%;
}
.formData-top {
    display: flex;
}
.dialog-footer {
    text-align: right;
}
.addicon {
    height: 22px;
    margin-left: 10px;
    margin-top: 5px;
}
.formData-img {
    margin-bottom: 20px;
    overflow: auto;
}
.upload {
    display: inline-block;
    margin-right: 6px;
}
</style>
<style lang="less">
.cus-infoes {
    .el-form-item {
        margin-bottom: 18px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
</style>
